import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=1fa87b26"
import script from "./infomation.vue?vue&type=script&lang=js"
export * from "./infomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports